<template>
  <div class="container">
    <div v-if="label" class="label">{{ label }}</div>
    <div class="qa-list" :style="`height:${height}px`">
      <div class="qa-item" v-for="(v,idx) in cList" :key="'qa-list-input-'+idx"
           :class="{'selected': selected && v.name === selected.name}"
          @click="clickItem(v)"  @dblclick="dblClick(v)">
        <div :contenteditable="v.edit"
             :ref="`qaName${idx}`"
             class="qa-name" @blur="onBlur(v, idx)">{{ v.name }}</div>
        <i class="btn-close material-icons" @click="$emit('delete', idx)">close</i>
      </div>
    </div>
    <div class="btn-wrapper">
      <input type="text" v-model="value" @keyup="e => value = e.target.value" @keyup.enter="onEnter">
      <button @click="onEnter">추가</button>
    </div>

  </div>
</template>

<script>
  export default {
    name: "QaListInput",
    props: {
      label: {
        type: String
      },
      list: {
        type: Array
      },
      height: {
        type: Number,
        default: 250
      }
    },
    created() {
      if(this.cList.length>0) {
        this.clickItem(this.cList[0]);
      }
    },
    data() {
      return {
        selected: undefined,
        value: ''
      }
    },
    methods: {
      dblClick(v) {
        v.edit = true;
        this.$forceUpdate();
      },
      onBlur(v, idx) {
        v.name = this.$refs[`qaName${idx}`][0].innerText;
        v.edit = false;
        this.$emit('update', idx, v.name);
      },
      clickItem(v) {
        this.selected = v;
        this.$emit('selected', v);
      },
      onEnter() {
        if(this.value!=='') {
          this.$emit('enter', this.value);
          this.value = '';
        }
      }
    },
    computed: {
      cList() {
        return this.list.map(i=>{
          i.edit = false;
          return i;
        });
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .container
    width 100%
  .label
    font-size 13px
    margin-bottom 4px
  .qa-list
    border 1px solid #dddddd
    overflow-y auto
    background white
  .qa-item
    padding 4px 8px
    font-size 13px
    display flex
    justify-content space-between
    align-items center
  .qa-item:hover
  .selected
    color #ff5722
    background #f5f5f5
    cursor pointer

  .qa-item:hover
    .btn-close
      display block

  .btn-close
    display none
    font-size 17px

  .qa-name
    white-space nowrap
  .qa-name:focus
    outline none



  .btn-wrapper
    margin-top 4px
    display flex
    align-items center

    input
      width 70%
      border 1px solid #dddddd
      padding 4px 8px
      height 30px
      border-radius 4px
    button
      border 0
      padding 5px
      height 30px
      background #dddddd
      border-radius 4px
      color #242428
      width calc(30% - 8px)
      margin-left 8px
    button:hover
      cursor pointer
      background #ff5722
      color white
</style>
